import React from "react";
import { useIntl } from "react-intl";
import PropTypes from "prop-types";

import ReportModelingEditDialogTable from "./report-modeling-edit-dialog-table.jsx";

import "./styles.less";
import { Box, Typography, Checkbox as MuiCheckbox } from "@mui/material";

const getRowId = row => row.key;

const createRowCellContent = (
    row,
    column,
    selected,
    onSelect,
    getCellValue = (row, column) => row[column.id],
    disabled=false
) => {
    const value = getCellValue(row, column);

    switch (column.type) {
        case "select":
            return (
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        width: "fit-content"
                    }}>
                    <MuiCheckbox
                        checked={selected}
                        disabled={disabled}
                        sx={{
                            "&.Mui-checked": {
                                color: "gray"
                            },
                        }}
                        onClick={() => {
                            onSelect(row, !selected)
                        }} />

                    {value && (
                        <Typography className="table-row-cell-text">
                            {value}
                        </Typography>
                    )}
                </Box>
            );

        default:
            return value && (
                <Typography className="table-row-cell-text">
                    {value.toString()}
                </Typography>
            )
    }
};

const ReportModelingEditDialogTableSelect = ({
    rows,
    selectedIds,
    onSelectRow,
    onSelectAll,
    disabled=false
}) => {
    const intl = useIntl();

    const columns = [
        {
            id: "select",
            type: "select",
            disabled: disabled 
        },
        {
            id: "key",
            title: intl.formatMessage({ id: "report-modeling-edit-dialog.select-table.columns.key" }),
            type: "text",
        },
        {
            id: "text",
            title: intl.formatMessage({ id: "report-modeling-edit-dialog.select-table.columns.text" }),
            type: "text",
        }
    ];

    const toolbarActions = [
        {
            id: "title",
            title: intl.formatMessage({ id: "report-modeling-edit-dialog.select-table.title" }),
            type: "text",
            position: "begin"
        }
    ];

    return (
        <ReportModelingEditDialogTable
            className="report-modeling-edit-dialog-table-select"
            columns={columns}
            rows={rows}
            toolbarActions={toolbarActions}
            selectedIds={selectedIds}
            onSelectRow={onSelectRow}
            onSelectAll={onSelectAll}
            createRowCellContent={(...args) => createRowCellContent(...args, disabled)}
            getRowId={getRowId}
            virtualize
        />
    );
};

ReportModelingEditDialogTableSelect.propTypes = {
    rows: ReportModelingEditDialogTable.propTypes.rows,
    selectedIds: ReportModelingEditDialogTable.propTypes.selectedIds,
    onSelectRow: ReportModelingEditDialogTable.propTypes.onSelectRow,
    onSelectAll: ReportModelingEditDialogTable.propTypes.onSelectAll,
    disabled: PropTypes.bool
};

export default ReportModelingEditDialogTableSelect;